<template>

    <v-layout>
        <a class="link mr-2" :href="href" target="_blank">{{ id || '-' }}</a>
        <div class="copy-button-container">
            <v-icon class="copy-button" small="small" title="Copy ID" @click="copyButton">mdi-content-copy</v-icon>
        </div>
    </v-layout>

</template>

<script>
import env from '../../tools/env'

export default {
  name: 'ExternalId',
  props: ['id', 'path'],
  computed: {
    href: {
      get () {
        return this.getDomain() + this.path
      }
    }
  },
  methods: {
    copyButton () {
      navigator.clipboard.writeText(this.id)
    },
    getDomain () {
      return {
        'dev': 'https://test2.rematch.tv',
        'preprod': 'https://test2.rematch.tv',
        'prod:': 'https://www.rematch.tv'
      }[env]
    }
  }
}

</script>

<style lang="scss" scoped>
.copy-button-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 16px;
    width: 16px;
    position: relative;

    .copy-button {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 20px;
        opacity: 0;
    }
}

td:has(:hover) .copy-button {
    opacity: 1;
    right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/tables/ExternalId.vue